var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'is-administrating': _vm.administrating,
    'has-background-warning': _vm.$projectId === 'fixed-dev'
  },attrs:{"id":"breadcrumbs"}},[_c('div',{staticClass:"container"},[_c('p',[_vm._l((_vm.breadcrumbs),function(route,index){return [_vm._v(" "+_vm._s(index > 0 ? " / " : "")+" "),_c('breadcrumb',{key:`breadcrumb-crumb-${index}`,attrs:{"route":route}})]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }